// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../models/dictionary.model';
import { IBaseType } from '../ibase-type.enum';

export interface IAssistedSelfServiceType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
    isCustomerAnonymous: boolean;
}

export class AssistedSelfServiceType implements IAssistedSelfServiceType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;
    public isCustomerAnonymous: boolean;

    /**
        Returns Add Funds AssistedSelfServiceType
    **/
    get AddFunds(): IAssistedSelfServiceType {
        return this.FromId(1);
    }
    /**
        Returns Upload Documents AssistedSelfServiceType
    **/
    get UploadDocuments(): IAssistedSelfServiceType {
        return this.FromId(2);
    }
    /**
        Returns eSign AssistedSelfServiceType
    **/
    get ESign(): IAssistedSelfServiceType {
        return this.FromId(3);
    }
    /**
        Returns Appt-Additional Services AssistedSelfServiceType
    **/
    get ApptAdditionalServices(): IAssistedSelfServiceType {
        return this.FromId(4);
    }
    /**
        Returns Three Day Permit AssistedSelfServiceType
    **/
    get ThreeDayPermit(): IAssistedSelfServiceType {
        return this.FromId(5);
    }
    /**
        Returns Registration Renewal AssistedSelfServiceType
    **/
    get RegistrationRenewal(): IAssistedSelfServiceType {
        return this.FromId(6);
    }
    /**
        Returns View Receipts AssistedSelfServiceType
    **/
    get ViewReceipts(): IAssistedSelfServiceType {
        return this.FromId(7);
    }
    /**
        Returns Driver License Replacement AssistedSelfServiceType
    **/
    get DriverLicenseReplacement(): IAssistedSelfServiceType {
        return this.FromId(8);
    }
    /**
        Returns Driver MVR AssistedSelfServiceType
    **/
    get DriverMVR(): IAssistedSelfServiceType {
        return this.FromId(9);
    }
    /**
        Returns Vehicle Payment Summary AssistedSelfServiceType
    **/
    get VehiclePaymentSummary(): IAssistedSelfServiceType {
        return this.FromId(10);
    }
    /**
        Returns ID Card Replacement AssistedSelfServiceType
    **/
    get IDCardReplacement(): IAssistedSelfServiceType {
        return this.FromId(11);
    }
    /**
        Returns Shop Specialty Plates AssistedSelfServiceType
    **/
    get ShopSpecialtyPlates(): IAssistedSelfServiceType {
        return this.FromId(12);
    }
    /**
        Returns Compliance Payment AssistedSelfServiceType
    **/
    get CompliancePayment(): IAssistedSelfServiceType {
        return this.FromId(13);
    }
    /**
        Returns Reset MFA AssistedSelfServiceType
    **/
    get ResetMFA(): IAssistedSelfServiceType {
        return this.FromId(14);
    }
    /**
        Returns Voter Registration AssistedSelfServiceType
    **/
    get VoterRegistration(): IAssistedSelfServiceType {
        return this.FromId(16);
    }
    /**
        Returns Knowledge Test AssistedSelfServiceType
    **/
    get KnowledgeTest(): IAssistedSelfServiceType {
        return this.FromId(17);
    }
    /**
        Returns eTitle Transfer Payment AssistedSelfServiceType
    **/
    get ETitleTransferPayment(): IAssistedSelfServiceType {
        return this.FromId(18);
    }
    /**
        Returns TeleMVD AssistedSelfServiceType
    **/
    get TeleMVD(): IAssistedSelfServiceType {
        return this.FromId(19);
    }
    /**
        Returns Forgot Username AssistedSelfServiceType
    **/
    get ForgotUsername(): IAssistedSelfServiceType {
        return this.FromId(20);
    }
    /**
        Returns VIN Inspection AssistedSelfServiceType
    **/
    get VINInspection(): IAssistedSelfServiceType {
        return this.FromId(21);
    }
    /**
        Returns Customer Survey AssistedSelfServiceType
    **/
    get CustomerSurvey(): IAssistedSelfServiceType {
        return this.FromId(22);
    }
    /**
        Returns Case ATP Employee Application AssistedSelfServiceType
    **/
    get CaseATPEmployeeApplication(): IAssistedSelfServiceType {
        return this.FromId(23);
    }
    /**
        Returns OHV Education Course AssistedSelfServiceType
    **/
    get OHVEducationCourse(): IAssistedSelfServiceType {
        return this.FromId(24);
    }
    /**
        Returns AZ MVD Now Claim Invitation AssistedSelfServiceType
    **/
    get AZMVDNowClaimInvitation(): IAssistedSelfServiceType {
        return this.FromId(26);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'AddFunds', displayValue: 'Add Funds', description: 'Add Funds', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('2', { id: 2, value: 'UploadDocuments', displayValue: 'Upload Documents', description: 'Upload Documents', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('3', { id: 3, value: 'ESign', displayValue: 'eSign', description: 'eSign', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('4', { id: 4, value: 'ApptAdditionalServices', displayValue: 'Appt-Additional Services', description: 'Appointment Additional Services', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('5', { id: 5, value: 'ThreeDayPermit', displayValue: 'Three Day Permit', description: 'Three Day Permit', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('6', { id: 6, value: 'RegistrationRenewal', displayValue: 'Registration Renewal', description: 'Registration Renewal', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('7', { id: 7, value: 'ViewReceipts', displayValue: 'View Receipts', description: 'View Receipts', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('8', { id: 8, value: 'DriverLicenseReplacement', displayValue: 'Driver License Replacement', description: 'Driver License Replacement', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('9', { id: 9, value: 'DriverMVR', displayValue: 'Driver MVR', description: 'Driver Motor Vehicle Record', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('10', { id: 10, value: 'VehiclePaymentSummary', displayValue: 'Vehicle Payment Summary', description: 'Vehicle Payment Summary', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('11', { id: 11, value: 'IDCardReplacement', displayValue: 'ID Card Replacement', description: 'Identification Card Replacement', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('12', { id: 12, value: 'ShopSpecialtyPlates', displayValue: 'Shop Specialty Plates', description: 'Shop for Specialty and Personalized Plates', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('13', { id: 13, value: 'CompliancePayment', displayValue: 'Compliance Payment', description: 'Compliance Payment', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('14', { id: 14, value: 'ResetMFA', displayValue: 'Reset MFA', description: 'Reset Multi-Factor Authentication', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('16', { id: 16, value: 'VoterRegistration', displayValue: 'Voter Registration', description: 'Voter Registration', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('17', { id: 17, value: 'KnowledgeTest', displayValue: 'Knowledge Test', description: 'Knowledge Test for Driver Credential', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('18', { id: 18, value: 'ETitleTransferPayment', displayValue: 'eTitle Transfer Payment', description: 'eTitle Transfer Payment', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('19', { id: 19, value: 'TeleMVD', displayValue: 'TeleMVD', description: 'TeleMVD', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('20', { id: 20, value: 'ForgotUsername', displayValue: 'Forgot Username', description: 'Forgot Username', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('21', { id: 21, value: 'VINInspection', displayValue: 'VIN Inspection', description: 'VIN Inspection', sortOrder: 999999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('22', { id: 22, value: 'CustomerSurvey', displayValue: 'Customer Survey', description: 'Customer Survey', sortOrder: 99999, active: true, isCustomerAnonymous: true });
        this._dictionary.add('23', { id: 23, value: 'CaseATPEmployeeApplication', displayValue: 'Case ATP Employee Application', description: 'Case ATP Employee Application', sortOrder: 1, active: true, isCustomerAnonymous: false });
        this._dictionary.add('24', { id: 24, value: 'OHVEducationCourse', displayValue: 'OHV Education Course', description: 'OHV Education Course', sortOrder: 999999, active: true, isCustomerAnonymous: false });
        this._dictionary.add('26', { id: 26, value: 'AZMVDNowClaimInvitation', displayValue: 'AZ MVD Now Claim Invitation', description: 'AZ MVD Now Claim Invitation', sortOrder: 999999, active: true, isCustomerAnonymous: false });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IAssistedSelfServiceType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IAssistedSelfServiceType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IAssistedSelfServiceType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IAssistedSelfServiceType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IAssistedSelfServiceType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
